import PropTypes from "prop-types";

const Recommendations = { side: PropTypes.string };

export default {
	Recommendations,
};
